<template>
<!-- 角色管理 -->
    <div class="table_container">
        <el-card class="fatherCard">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item>
                    <el-breadcrumb-item>系统管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="childrenCardDiv">
                <!--角色信息展示表格-->
                <el-button type="success" @click="openDialog('add')" class="addButton">新增</el-button>
                <el-table :data="roleList"  class="roleTable" :header-cell-style="{background:'#eef1f6',color:'#606266'}"> 
                    <el-table-column type="index" label="序号" width="50"  align="center"></el-table-column>       
                    <el-table-column prop="roleName" label="角色名称" width="250"  align="center" ></el-table-column>
                    <el-table-column prop="roleId" label="角色ID"  v-if="false"></el-table-column>
                    <el-table-column prop="roleCode" label="角色代码" width="200" align="center"></el-table-column>
                    <el-table-column prop="createName" label="创建人" width="250" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="250" align="center"> </el-table-column>
                    <el-table-column prop="updateTime" label="最后修改时间" width="200" align="center"></el-table-column>
                    <el-table-column prop="roleStatus" label="角色状态" width="150" align="center">
                        <template slot="header" >
                            <div class="switchDiv">
                                <span>角色状态</span>
                                <el-switch v-model="switchValue"  active-color="#13ce66"  inactive-color="#909399"></el-switch>
                            </div>
                        </template>
                        <template slot-scope="scope">{{ scope.row.state === '0' ? '禁用' : '在用' }}</template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="250"  align="center">
                        <template slot-scope="scope">
                            <el-button @click="openDialog(scope.row)" type="primary" size="small">编辑</el-button>
                            <el-button @click="modifyState(scope.row)" :type="switchValue === true ? 'danger' : 'success'" size="small">{{switchValue === true ? '禁用' : '启用'}}</el-button>
                        </template>
                    </el-table-column>
                    <template slot="empty">
                        <el-empty :image-size="100" description="未查询到任何角色，请添加或查看网络！"></el-empty>
                    </template>
                </el-table>
                <el-pagination v-show="totalCount > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                    :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryParams.pageSize" :total="totalCount" class="page">   
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增/修改角色对话框-->        
        <el-dialog width="800px" :title="dialogTitle" :visible.sync="dialogVisible" :before-close="handleCloseDialog">
            <div>
                <el-form ref="dialogForm" :rules="rules" :model="dialogForm" label-width="80px">
                    <el-form-item label="角色代码" prop="roleCode">
                        <el-input v-model.trim="dialogForm.roleCode"></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称" prop="roleName" >
                        <el-input v-model.trim="dialogForm.roleId" v-if="false"></el-input>
                        <el-input v-model.trim="dialogForm.roleName"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitRoleInfo('dialogForm')" :loading="submitLoading">{{ submitLoading ? '提交中 ...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
    </div>  
</template>

<script>
import {queryRoleListByPage ,addRole ,modifyRole ,updateRoleState} from '../../api/role'
export default {
    data() {
        return {
            totalCount: 0,                  //总数据条数
            queryParams: {
                roleId: '',
                roleCode: null,
                roleName: null,
                state:'1',
                pageNum: 1,
                pageSize:10,
                roleSort:null,
                orderByColumn:null,
                isAsc:null
            },
            roleList: [],                   //表格数据
            switchValue: true,      
            dialogVisible: false,           //对话框显示标志
            dialogForm: {},                 //对话框表单
            dialogTitle: '用户信息',         //对话框标题
            propVisible:true,
            submitLoading: false,           //提交按钮加载
            rules: {
                roleName: [
                    {required: true, message: '角色名不能为空', trigger: 'blur'},               
                    {pattern: /^[\u4E00-\u9FA5]+$/, message: '真实姓名只能为中文',trigger: 'blur'}
                ],
                roleCode: [
                    {required: true, message: '角色代码不能为空', trigger: 'blur'},
                ],

            },
        };
    },
    created() {
        this.getRoleInfo();

    },
    watch:{
        switchValue: function(newSwitchValue, oldSwitchValue){
            if(newSwitchValue === true){
                this.queryParams.state = '1';
            }else {
                this.queryParams.state = '0';
            }
            this.getRoleInfo();
        }
    },
    methods: {
        //查询所有用户角色
        getRoleInfo() {
           queryRoleListByPage(this.queryParams).then(res => {
               if(res.data.code === 200) {
                    this.roleList = res.data.rows;
                    this.totalCount = res.data.total;
                }else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });  
                }              
            })
        },
         //改变当前记录条数
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.queryParams.pageNum = 1;
            this.getRoleInfo();
        },
        //改变当前页码，重新发送请求
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getRoleInfo();
        },
        //打开对话框
        openDialog(val){
            if(val === 'add'){
                //打开新增用户
                this.dialogTitle = '新增角色对话框';
                this.dialogForm = {};
                this.propVisible = true;
            }else{
                if(JSON.parse(this.$store.state.loginInfo).roles === '阅卷官' && (val.roleCode === '"super_admin"' ||  val.roleCode === 'examiner')) {
                    this.$message({
                        message: '您没有权限修改信息！',
                        type: 'warning'
                    });
                    return
                } else {
                    this.dialogTitle = '修改角色对话框';
                    this.propVisible = false;
                    this.dialogForm = {
                        roleId: val.roleId,
                        roleName:val.roleName,
                        roleCode: val.roleCode,
                        state: val.state
                    }
                }
            }
            this.dialogVisible = true;
        },
        //提交用户信息
        submitRoleInfo(formName) {             
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    if(this.propVisible){
                        this.dialogForm.createName = JSON.parse(this.$store.state.loginInfo).userName;                      
                        addRole(JSON.stringify(this.dialogForm)).then(res => {
                            this.submitLoading = false; 
                            if(res.data.code === 200) {
                                this.dialogVisible = false;
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '成功创建新角色！',
                                    type: 'success',
                                }); 
                                this.getRoleInfo();
                            }else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  

                            }
                        })
                    }else {                       
                        modifyRole(JSON.stringify(this.dialogForm)).then(res => {
                            this.submitLoading = false;
                            if(res.data.code === 200) {
                                this.dialogVisible = false;
                                this.$refs[formName].resetFields();   
                                this.$message({
                                    message: '成功修改用户信息！',
                                    type: 'success',
                                })
                                this.getRoleInfo();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  
                             
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: '角色信息格式错误，请检查后重试！',
                        type: 'error'
                    });  
                }
            });            
        },
       
        //对话框关闭提醒
        handleCloseDialog(done) { 
            this.$confirm('确认关闭？').then(_ => {
                this.$refs['dialogForm'].resetFields();
                done();
            }).catch(_ => {});
        },

         //禁用
        modifyState(row) {             
            if(JSON.parse(this.$store.state.loginInfo).roles === '阅卷官' && (row.roleCode === '"super_admin"' ||  row.roleCode === 'examiner')) {
                this.$message({
                    message: '不可禁用',
                    type: 'warning'
                });
            } else {
                this.dialogForm = row;
                if(this.switchValue === true){
                    this.dialogForm.state = '0';
                }else {
                    this.dialogForm.state = '1';
                }
                updateRoleState(JSON.stringify(this.dialogForm)).then(res => {
                    if(res.data.code === 200) {
                        this.$message({
                            message: '已禁用！',
                            type: 'success',
                        })
                        this.dialogForm = {};
                        this.getRoleInfo();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });  
                        
                    }
                })
            }
          
        },
    }
};
</script>
<style lang="css" scoped>
    .fatherCard {
        height: 88vh;
    }
    .currentLocation {
        font-weight:bold
    }
    .page {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }    
    .switchDiv {
        display: flex;
        flex-flow: column;
        align-items: center;
    }


    .permissionDiv {
        height: 550px;
        margin-top: -20px;
    }
    .roleCodeInput {
        width: 200px;
    }

    .leftDiv {
        float: left;
        width: 500px;
    }
    .middleDiv {
        float: left;
        width: 200px;
        padding-top: 50px;
        margin-left: 10px;
    }
    .rightDiv {
        float: left;
        width: 500px;
    }
    .closeBtn {
        margin-right: 650px;
    }
    .manageForm {
        margin-left: 40px;
    } 
    .roleTable {
        margin-top: 10px;
    }
</style>
